/**
 * Validates if a string is a valid GUID (UUID)
 * @param {string} guid - The string to validate
 * @returns {boolean} - True if valid GUID, false otherwise
 */
export const isValidGuid = (guid) => {
  if (!guid || typeof guid !== 'string') {
    return false
  }
  // GUID regex pattern: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
  const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
  return guidRegex.test(guid)
}
/**
 * Empty GUID constant
 */
export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000'
